<template>
  <transition name="modal">
    <div
      v-if="isShow"
      class="modal-wrapper"
      :style="{ backgroundColor: `rgba(0,0,0,${opacity})` }"
    >
      <div :class="['modal-content', `modal-content-${position}`]">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  props: {
    show: Boolean,
    position: {
      type: String,
      default: 'middle'
    },
    opacity: {
      type: Number,
      default: 0.3
    }
  },
  data() {
    return {}
  },
  computed: {
    isShow() {
      return this.show
    }
  },
  watch: {
    isShow(val) {
      this.disabledMove(val)
    }
  },
  methods: {
    // 显示弹窗状态下，禁止背景滚动
    disabledMove(val) {
      if (val) {
        const scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop
        document.body.style.cssText += `position:fixed;width:100%;top:-${scrollTop}px;`
      } else {
        const body = document.body
        body.style.position = ''
        const top = body.style.top
        body.scrollTop = document.documentElement.scrollTop - parseInt(top)
        body.style.top = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  /*background-color: rgba(0,0,0,0.7);*/
  z-index: 9999;
}
.modal-content {
  position: absolute;
  left: 50%;
  /*width:100%;*/
}
.modal-content-middle {
  top: 46%;
  transform: translate(-50%, -50%);
}
.modal-content-bottom {
  bottom: 0;
  transform: translate(-50%, 0);
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s;
  .modal-content-middle {
    transition: transform 0.3s;
    transform: translate(-50%, -50%) scale(1);
  }
  .modal-content-bottom {
    transition: transform 0.3s;
    transform: translate(-50%, 0);
  }
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-enter {
  .modal-content {
    transform: translate(-50%, -50%) scale(0);
  }
  .modal-content-bottom {
    transform: translate(-50%, 100%);
  }
}
</style>
